import SvgPhotoFilmIcon from "jsx:../../../Images/Icons/FontAwesome/solid/photo-film.svg";
import { SvgIcon, SxProps } from "@mui/material";

export function PhotoFilmIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgPhotoFilmIcon}
            inheritViewBox
            sx={{
                color: "var(--community-color-primary-text)",
                ...props,
            }}
        />
    );
}
